<template>
  <div class="footer">
    <section class="menu">
      <div class="page-inner">
        <ul class="column">
          <li class="cell" is="router-link" :to="{ name: 'index' }">首页</li>
          <li class="cell" is="router-link" :to="{ name: 'index', query: { goAnchor: 'inquiry'} }">询价</li>
          <li class="cell" is="router-link" :to="{ name: 'index', query: { goAnchor: 'inquiry'} }">发货</li>
        </ul>

        <ul class="column">
          <li class="cell" is="router-link" :to="{ name: 'activitycenter' }">活动中心</li>
          <li class="cell" is="router-link" :to="{ name: 'activitycenter', query: { goAnchor: 'activity'} }">首单抽奖</li>
        </ul>

        <ul class="column">
          <li class="cell" is="router-link" :to="{ name: 'productcenter' }">产品中心</li>
          <li class="cell" is="router-link" :to="{ name: 'productcenter', query: { goAnchor: 'huozhu'} }">货主</li>
          <li class="cell" is="router-link" :to="{ name: 'productcenter', query: { goAnchor: 'siji'} }">司机</li>
        </ul>

        <ul class="column">
          <li class="cell" is="router-link" :to="{ name: 'recruitment' }">招贤纳士</li>
          <li class="cell" is="router-link" :to="{ name: 'recruitment', query: { goAnchor: 'inquiry'} }">招聘</li>
        </ul>

        <ul class="column">
          <li class="cell" is="router-link" :to="{ name: 'aboutus' }">关于我们</li>
          <li class="cell" is="router-link" :to="{ name: 'aboutus', query: { goAnchor: 'jianjie'} }">公司简介</li>
          <li class="cell" is="router-link" :to="{ name: 'aboutus', query: { goAnchor: 'licheng'} }">发展历程</li>
          <li class="cell" is="router-link" :to="{ name: 'aboutus', query: { goAnchor: 'yuanjing'} }">企业文化</li>
          <li class="cell" is="router-link" :to="{ name: 'aboutus', query: { goAnchor: 'aboutus'} }">联系我们</li>
        </ul>

        <div class="wechat-qrcode-wrapper">
          <div class="icon"></div>
        </div>


      </div>
    </section>

    <section class="copyright">
      <span>©杭州享运物流 版权所有 <a style="color:#FFF;" href="https://beian.miit.gov.cn/" target="_blank">浙ICP备17007786号-2</a></span>

      <div style="width:300px;margin:0 auto; padding:0px 0;">
        <a target="_blank" href=" " style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
          <img src="../assets/images/beian.png" style="float:left;"/>
          <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">
            <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33011002014778" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;color:#939393;">浙公网安备 33011002014778号</a>
          </p>
        </a>
      </div>
    </section>
  </div>
</template>

<script type="text/ecmascript-6">
  export default {
    name: 'footers'
  }

</script>

<style rel="stylesheet/scss" lang="scss">
  @import "../style/_variable";
  .footer {

    .menu {
      padding: 40px 0 40px 0;
      background-color: $bg-clr;
      overflow: hidden;
      .column {
        display: inline-block;
        vertical-align: top;
        margin-right: 70px;
        .cell {
          display: block;
          margin: 22px 0;
          color: $text-clr_light;
          &:first-child {
            color: $text-clr;
            font-size: 18px;
          }
        }
      }

      .wechat-qrcode-wrapper {
        float: right;
        .icon {
          width: 204px;
          height: 204px;
          background: url("../assets/images/qrcode.png") center no-repeat;
        }
        p {
          text-align: center;
          font-size: 16px;
          margin-top: 30px;
        }
      }
    }


    .copyright {
      // height: 108px;
      display: flex;
      flex-flow: column;
      background-color: $bg-clr_dark;
      text-align: center;
      span {
        color: white;
        line-height: 108px;
      }
      .chengxin {
        margin: 30px 0 -30px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/footer.vue